<script setup>
import { Link } from '@inertiajs/vue3';
import Logo from '@/components/icons/Logo.vue';
import logoUrl from '@/assets/login-logo.png';
import GlobalLoadingOverlay from '@/components/GlobalLoadingOverlay.vue';
import SelectLanguage from '@/views/linkarme/components/SelectLanguage.vue';
</script>

<template>
    <div class="overflow-hidden bg-surface-50 dark:bg-surface-950 w-full min-h-screen">
        <div class="min-h-screen flex flex-col">
            <!-- Header -->
            <header class="relative w-full py-4 px-6 bg-surface-0 dark:bg-surface-900 border-b border-surface-200 dark:border-surface-700">

                <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                    <Link href="/" class="flex items-center gap-3">
                        <img :src="logoUrl" alt="LinkArMe" class="h-10 w-auto" />
                    </Link>
                </div>
                
                <div class="max-w-7xl mx-auto flex justify-end items-center">
                    <SelectLanguage context="client" />
                </div>

            </header>

            <!-- Main Content -->
            <main class="flex-1 flex items-center justify-center p-6">
                <div class="w-full max-w-6xl">
                    <slot />
                </div>
            </main>

            <!-- Footer -->
            <footer class="w-full py-4 px-6 bg-surface-0 dark:bg-surface-900 border-t border-surface-200 dark:border-surface-700">
                <div class="max-w-7xl mx-auto text-center">
                    <p class="text-sm text-surface-500 dark:text-surface-400">
                        &copy; {{ new Date().getFullYear() }} LinkArMe. {{ $t('All rights reserved') }}.
                    </p>
                </div>
            </footer>
        </div>

        <GlobalLoadingOverlay />
    </div>
</template>

<style scoped>
</style>